var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Row",
    { attrs: { gutter: 16 } },
    [
      _c(
        "Col",
        { attrs: { span: "24", label: "发货单列表", name: "preSaleDelivery" } },
        [
          _c(
            "div",
            { staticClass: "global-tool-bar" },
            [
              _c("PreSaleDeliveryList", {
                ref: "preSaleDeliveryList",
                model: {
                  value: _vm.preSaleDelivery,
                  callback: function ($$v) {
                    _vm.preSaleDelivery = $$v
                  },
                  expression: "preSaleDelivery",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }